import { styled } from '@mui/material/styles';
import { SliderSectionContiner, TourCard } from 'views/common/components';

export const StyledSliderSectionContiner = styled(SliderSectionContiner)(
  ({ theme }) => ({
    '& .react-multi-carousel-list': {
      [theme.breakpoints.down('lg')]: {
        paddingBottom: theme.spacing(5.75),
      },
    },
    '& .MuiTypography-root.title': {
      fontSize: theme.spacing(3.5),
      [theme.breakpoints.down('lg')]: {
        fontSize: theme.spacing(2.5),
      },
    },
    '& .react-multiple-carousel__arrow': {
      [theme.breakpoints.down('lg')]: {
        display: 'none',
      },
    },
    '& .react-multi-carousel-dot-list': {
      [theme.breakpoints.up('lg')]: {
        display: 'none',
      },
    },
    '& .react-multi-carousel-item .CarouselItem': {
      height: '99.2%',
    },
  }),
);
export const StyledTourCard = styled(TourCard)(({ theme }) => ({
  '& .TCName': {
    minHeight: theme.spacing(6.5),
  },
  '& .react-multiple-carousel__arrow': {
    [theme.breakpoints.down('lg')]: {
      display: 'block',
    },
  },
}));
